<template>
  <div class="pr-3 entries-box vertical layout">
    <div class="entries-box __blur"></div>
    <div
      class="entries-box __header horizontal layout center"
      :class="{black: slide.textColour === '#ffffff'}"
    >
      <div class="flex entries-count">
        {{ $t('entries') }}
        <span>{{ countWheelEntries | formatTotalPoint }}</span>
      </div>
      <div
        class="entries-box __reset horizontal layout center"
        v-if="!isABTestCollabTeamEdit &&
          oldWinner !== null &&
          slide.metadata &&
          slide.metadata.autoFillParticipantName &&
          (pendingEntriesCount || oldEntryFromAudienceCount)
        "
      >
        <div
          class="pending-count new-audience horizontal layout center"
          v-tooltip="`${pendingEntriesCount} have entered since the last spin.<br />
          Click “Update Wheel” to add them.`"
          v-if="pendingEntriesCount"
        >
          <span v-if="pendingEntriesCount"></span>
          {{ pendingEntriesCount | formatTotalPoint }}
        </div>
        <div
          class="pending-count horizontal layout center"
          v-tooltip="`${oldEntryFromAudienceCount} have gone inactive since the last spin.<br />
          Click “Update Wheel” to remove them.`"
          v-if="oldEntryFromAudienceCount"
        >
          <span v-if="oldEntryFromAudienceCount"></span>
          {{ oldEntryFromAudienceCount | formatTotalPoint }}
        </div>

        <div @click="openPopupUpdateWheel()" class="horizontal layout center btn-update-wheel">
          {{ $t('updateWheelButton') }}
        </div>
      </div>
    </div>
    <form
      class="entries-box __input-entry horizontal layout center"
      @submit="submitNewEntry"
    >
      <div class="relative flex mr-2">
        <aha-input
          type="text"
          :placeholder="$t('entriesPlaceholder')"
          :disabled="isABTestCollabTeamEdit || isBackstage"
          v-model="newEntry"
          :classes="variant === 'white' ? 'light' : 'dark'"
          :maxLength="limitEntryLength"
          @focus="onFocusEntryInput"
          @blur="onBlurEntryInput"
          @keyup="onKeyUpEntryInput"
          :class="{'disabled': isABTestCollabTeamEdit || isBackstage}"
        >
        </aha-input>
      </div>
      <aha-button
        type="submit"
        :disabled="isAddButtonDisabled"
      >
        <span v-if="!submiting">{{ $t('addButton') }}</span>
        <aha-spinner v-else variant="white" />
      </aha-button>
    </form>
    <div class="flex entries-box __list">
      <p class="text-center text-base-60" v-if="slide.loadedSpinnerWheel && !entries.length">
        {{ $t('noEntryYet') }}
      </p>
      <ul class="pl-0">
        <li v-for="(item, index) in entries" :key="index">
          {{ item.name }}
          <font-awesome-icon
            v-if="!isABTestCollabTeamEdit && item.entryType === 'manual_presenter' && !isBackstage"
            icon="trash-alt"
            class="remove-entry"
            @click="clickRemoveEntry(item)"
            v-tooltip="'Delete this entry'"
          />
        </li>
      </ul>
    </div>

    <aha-modal
      @hide="isShowResetWheel = false"
      title="Update the wheel"
      v-if="isShowResetWheel"
      size="md"
    >
      <p>
        This will add <span class="font-bold">
          {{ pendingEntriesCount | formatTotalPoint }} new
          {{ getParticipantText }}</span> who have entered since the last spin.
      </p>
      <template #action>
        <aha-link has-margin-right @click="isShowResetWheel = false">
          <span class="font-bold">Cancel</span>
        </aha-link>
        <aha-button
          type="button"
          class="confirm-modal-ok-btn"
          @click="ressetWheel"
          :disabled="submitResetSpinnerWheel"
        >
          Update <aha-spinner variant="white" v-if="submitResetSpinnerWheel" class="ml-1" />
        </aha-button>
      </template>
    </aha-modal>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Socket from '@/socket'
import SlideOptionApi from '@/api/slideOption'
import SlideApi from '@/api/slide'
import Util from '@/util'

export default {
  components: {
  },
  props: {
    variant: {
      type: String,
      default: 'white',
    },
    entries: {
      type: Array,
      default: () => {
        return []
      },
    },
    createNewEntry: {
      type: Function,
      default: () => {
        return null
      },
    },
    removeEntry: {
      type: Function,
      default: () => {
        return null
      },
    },
    resetSpinnerWheel: {
      type: Function,
      default: () => {
        return null
      },
    },
    isUserOwnPresentation: {
      type: Boolean,
      default: false,
    },
    pendingEntriesCount: {
      type: Number,
      default: 0,
    },
    oldEntryFromAudienceCount: {
      type: Number,
      default: 0,
    },
    oldWinner: {
      type: Object,
      default: null,
    },
    countWheelEntries: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      newEntry: '',
      limitEntryLength: 25,
      submiting: false,
      submitResetSpinnerWheel: false,
      isShowResetWheel: false,
    }
  },
  computed: {
    ...mapState({
      slide: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      isDisableEditSlide: (state) => state.isDisableEditSlide,
    }),
    ...mapGetters(['isBackstage']),
    getParticipantText() {
      if (this.pendingEntriesCount === 1) {
        return 'participant'
      }
      return 'participants'
    },
    isAddButtonDisabled() {
      return this.newEntry.length > this.limitEntryLength ||
        this.submiting || this.isBackstage || this.isABTestCollabTeamEdit
    },
    isABTestCollabTeamEdit() {
      if (this.presentation.accountId &&
        !this.presentation.hasSharedUser && this.presentation.accountId % 2 === 0
        && this.isDisableEditSlide) {
        return true
      }
      return false
    },
  },
  destroyed() {
    this._updateSlideActiveFocusingInput(false)
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    onFocusEntryInput() {
      this._updateSlideActiveFocusingInput(true)
    },
    onBlurEntryInput() {
      this._updateSlideActiveFocusingInput(false)
    },
    _updateSlideActiveFocusingInput(boolean) {
      this.updateSlideActiveAction({
        isFocusingInput: boolean,
      })
    },
    onKeyUpEntryInput() {
      if (this.newEntry.length > this.limitEntryLength) {
        this.newEntry = this.newEntry.substr(0, this.limitEntryLength)
      }
    },
    async submitNewEntry(event) {
      event.preventDefault()
      if (this.isABTestCollabTeamEdit) return
      if (this.slide.wheelStatus === 'spinning') return
      if (!this.newEntry || this.newEntry.length > 25 || this.submiting) return
      if (this.newEntry && !this.newEntry.trim()) return
      this.submiting = true
      const payload = {
        accessCode: this.presentation.uniqueAccessCode,
        presentationId: this.presentation.id,
        order: 1,
        slideId: this.slide.id,
        socketId: Socket.getSocketId(),
        title: this.newEntry,
      }
      if (this.slide.SlideOptions.length) {
        payload.order = this.slide.SlideOptions[0].order / 2
      }
      if (!payload.order) payload.order = 1
      try {
        const slideOption = await SlideOptionApi.createSlideOption(payload)
        this.newEntry = ''

        this.$store.state.slideActive.SlideOptions.unshift(slideOption)
        this.updateSlideActiveAction({
          SlideOptions: this.slide.SlideOptions,
        })
        this.createNewEntry(slideOption)
      } catch {
        this.$store.dispatch('setSyncPresentation', 3)
        // do notthing
      }
      this.submiting = false
    },

    async clickRemoveEntry(entry) {
      if (this.isABTestCollabTeamEdit || this.isBackstage) return
      if (this.slide.wheelStatus === 'spinning') return
      if (entry.entryType === 'manual_presenter') {
        const payload = {
          accessCode: this.presentation.uniqueAccessCode,
          deleted: true,
          presentationId: this.presentation.id,
          presenting: false,
          socketId: Socket.getSocketId(),
        }
        try {
          SlideOptionApi.updateSlideOption(entry.id, payload)
          const indexOption = this.$store.state.slideActive.SlideOptions.findIndex((item) => {
            return item.id === entry.id
          })
          if (indexOption !== -1) {
            this.$store.state.slideActive.SlideOptions.splice(indexOption, 1)
          }

          this.updateSlideActiveAction({
            SlideOptions: this.slide.SlideOptions,
          })
        } catch {
          this.$store.dispatch('setSyncPresentation', 3)
          // do notthing
        }
      }
      this.removeEntry(entry)
    },

    openPopupUpdateWheel() {
      if (this.slide.wheelStatus === 'spinning') return
      this.isShowResetWheel = true
    },

    async ressetWheel() {
      if (this.slide.wheelStatus === 'spinning') return
      this.submitResetSpinnerWheel = true
      try {
        await SlideApi.updateTheWheel(this.slide.id, {
          uniqueAccessCode: this.presentation.uniqueAccessCode,
          entries: this.entries,
        })
      } catch {
        Util.showToastError('Fail to update spinner wheel')
      }

      this.resetSpinnerWheel()
      this.submitResetSpinnerWheel = false
      this.isShowResetWheel = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.entries-box {
  &.__header {
    padding: 12px 0;
    font-weight: bold;
    @apply text-base-80;

    &.black {
      color: #fff;
    }
    .entries-count {
      font-size: 14px;
      span {
        font-weight: normal;
        background: rgba(175, 175, 175, 0.3);
        border-radius: 4px;
        padding: 2px 6px;
        display: inline-block;
        margin-left: 5px;
        font-size: 12px;
      }
    }
  }

  .pending-count {
    margin-right: 10px;
    font-size: 12px;
    font-weight: normal;

    span {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      display: block;
      background-color: #AFAFAF;
      margin-right: 2px;
    }

    &.new-audience {
      span {
        background-color: #33C173;
      }
    }
  }

  &.__blur {
    position: absolute;
    height: 300px;
    width: 280px;
    top: 60px;
    left: 14px;
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
    z-index: -1;
  }

  & ::v-deep input {
      padding: 4px 8px;
      border-radius: 6px;
      font-size: 14px;
      width: 100%;
      padding-right: 30px;
      height: 2rem;
      &.dark {
        @apply text-secondary-20 bg-transparent border border-secondary-20;
        @apply hover:border-primary-90 focus:border-primary-90;
      }

      &::placeholder {
        font-size: 14px;
      }
    }

  & ::v-deep .aha-input--char-counter {
    height: 2rem;
    font-size: 12px;
  }

  &.__input-entry {
    margin-bottom: 16px;

    .count {
      position: absolute;
      right: 7px;
      font-size: 14px;
      opacity: 0.6;
      top: 8px;
    }

    > .aha-button {
      margin-top: -5px;
      padding: 4px 0px;
      font-size: 14px;
      min-width: 3rem;
      & ::v-deep .aha-spinner {
        margin-bottom: -5px;
      }
    }

    &::v-deep {
      .aha-input__wrapper.disabled {
        input:hover {
          border-color: #D3D7E1;
          cursor: not-allowed;
        }
      }
    }
  }

  &.__reset {
    font-size: 12px;
    .btn-update-wheel {
      @apply text-primary-90 font-bold;
      cursor: pointer;
      margin-left: 2px;

      &:hover {
        @apply text-primary-100;
      }
    }
  }

  &.__list {
    overflow-y: auto;

    p {
      margin-top: 20px;
      font-size: 14px;
    }

    ul {
      li {
        font-size: 14px;
        padding: 6px 10px;
        border-radius: 4px;
        position: relative;
        list-style-type: none;
        &:nth-child(2n + 1) {
          background: rgba(211, 215, 225, 0.3);
        }

        .remove-entry {
          @apply text-base-60;
          position: absolute;
          right: 10px;
          top: 10px;
          display: none;
          cursor: pointer;
        }

        &:hover {
          .remove-entry {
            display: block;
            &:hover {
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
}
</style>
